
if (!WEBPACK_ENV.ESMODULE) {
  // Include polyfills
  // We don't have globbing support for require calls, so include them separately
  require('./polyfills/array-find-for-ie11.js')
  require('./polyfills/array-from-for-ie11.js')
  require('./polyfills/custom-events-for-ie11.js')
  require('./polyfills/element-classlist-for-ie11.js')
  require('./polyfills/element-matches.js')
  require('./polyfills/get-scrolling-element.js')
  require('./polyfills/string-includes.js')
  require('./polyfills/string-starts-with.js')
}

// Include helpers
// We don't have globbing support for require calls, so include them separately
require('./helpers/classnames.js')
require('./helpers/prevent-transitions-on-load.js')
require('./helpers/vh-mobile-device-fix.js')

if (!WEBPACK_ENV.ESMODULE) {
  // POLYFILLS THAT ARE ALSO NEEDED IN ES6 MODULES SHOULD BE IMPORTED INTO MAIN!

  window.Promise = require('promise-polyfill').default
  window.fetch = require('unfetch').default
}
